import React from 'react';

import { getBrandCDNUrl } from 'modules/shared/utils';

import { BrandBannerProps } from './brand-banner-type';

import styles from './brand-banner-component.module.css';

export const BrandBanner: React.FC<BrandBannerProps> = React.memo(({ name, thumbnail }: BrandBannerProps) => {
    if (!thumbnail) {
        return <React.Fragment></React.Fragment>;
    }
    return (
        <div className={styles.bannerContainer}>
            <picture>
                <img className={styles.brandBanner} alt={name} src={getBrandCDNUrl(thumbnail)} />
            </picture>
        </div>
    );
});
